import { YDatabase } from '@databases/collab/y-database';
import { Properties as FieldProperties } from '@databases/collab/y-field';
import * as Y from 'yjs';

/**
 * Pulls out template ID from a nested object into the string property
 */
export function templateId(documentId: string, ydb: YDatabase) {
  for (const fieldId of ydb.fields) {
    const field = ydb.fieldsById[fieldId];
    const fieldMap = field.unwrap();
    if (fieldMap instanceof Y.Map) {
      const parentPageSetting = fieldMap.get(FieldProperties.settingParentPage);
      if (parentPageSetting && typeof parentPageSetting === 'object') {
        if (
          'contentId' in parentPageSetting &&
          typeof parentPageSetting.contentId === 'string'
        ) {
          field.parentPage = parentPageSetting.contentId;
        }
      }
    }
  }
}
